import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { MainGameScene } from './scenes/MainGameScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.HEADLESS,
  parent: 'app',
  width: window.innerWidth,
  height: window.innerHeight,
  scene: [BootScene, MainGameScene],
  audio: {
    disableWebAudio: false,
  },
  banner: false,
};

new Phaser.Game(config);